import { useEffect } from "react"
import "../../styles/forest.scss"
import "../../styles/reception.scss"
import { Menu } from "../components/Menu"
import { Template } from "../components/Template"
import type { TemplateProps } from "../types"

export function ForestTemplate({ title, children }: TemplateProps) {
  useEffect(() => {
    document.title = title
  }, [title])

  return (
    <Template className="forestTemplate">
      <div id="forest"></div>
      <Menu />
      <div className="content">
        <article>{children}</article>
      </div>
    </Template>
  )
}
